"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializedBoundaryStateSchema = void 0;
const zod_1 = require("zod");
const BoundaryCharacteristicStateSummaryExternal_1 = require("./BoundaryCharacteristicStateSummaryExternal");
const BoundaryErrorsDefinition_1 = require("../DesignModels/BoundaryErrorsDefinition");
exports.SerializedBoundaryStateSchema = zod_1.default.object({
    characteristicValues: BoundaryCharacteristicStateSummaryExternal_1.BoundaryCharacteristicStateSummaryExternalSchema.array(),
    insightsErrors: zod_1.default.lazy(() => BoundaryErrorsDefinition_1.IBoundaryErrorSchema).array(),
    isPartialResolution: zod_1.default.boolean().optional(),
});
//# sourceMappingURL=SerializedBoundaryState.js.map